import { Link } from '../../../atoms/link/models/link.interfaces';

export interface StandbyMessage {
  id: string;
  title: string;
  message: string;
  action: Link;
}
